module.exports = __webpack_public_path__ + "static/media/enriched-air-diver-bg.483d990e.jpg";